import React, { useEffect, useState } from "react";
import { Modal, ConfigProvider, Divider } from "antd";
import { message, Select } from "antd";
import useUserStore from "../../stores/store";
import {
  getPaymentMethods,
  orderPaymentRefund,
} from "../../services/order-processing-service";
import CustomLoader from "../menu/CustomLoader";
import useScrollLock from "../../hooks/useScrollLock";

/**
 * This modal will appear to refund payment
 *
 * @param {*} param0
 * @returns
 */
function OrderPaymentRefundModal({ openModal, params }) {
  const [defaultRef, setDefaultRef] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("CASH");
  const [paymentMethodList, setPaymentMethodList] = useState([]);
  const [totalPayable, setTotalPayable] = useState(0);

  // Lock scroll when modal is open
  useScrollLock(openModal);

  const { user, adminsPaymentOptions, setNetworkCall, showNotification } = useUserStore();

  const clearFields = (isOnSubmit = false) => {
    setDefaultRef("");
    setPaymentMethod("CASH");
    
    if (isOnSubmit) {
      setTotalPayable(0);
    }
  };

  const handleCancel = () => {
    clearFields();
    params.onCancel();
  };

  const handleOk = async () => {
    setNetworkCall(true);

    const result = await orderPaymentRefund(
      user.token.token,
      params.order.orderId,
      paymentMethod,
      totalPayable,
      defaultRef
    );

    setNetworkCall(false);

    if (!result.success) {
      message.warning(result.message);
      return;
    }

    handleCancel();
  };

  const onSelectPaymentMethod = (val) => {
    const selectedItem = paymentMethodList.find((it) => it.value === val);
    setPaymentMethod(selectedItem.value);
  };


  useEffect(() => {
    setTotalPayable(0);

    if (params.order.refundInfo) {
      setTotalPayable(params.order.refundInfo.totalRefundAmount);
    }
  }, [params.order]);

  // Fetch payment methods list
  useEffect(() => {
    const options = getPaymentMethods(adminsPaymentOptions);
    
    setPaymentMethodList(JSON.parse(JSON.stringify(options)));
    setPaymentMethod(options[0]?.value);
  }, [adminsPaymentOptions]);

  return (
    <ConfigProvider
      theme={{
        components: {
          Button: {
            defaultHoverBorderColor: "#FFD700",
            defaultHoverColor: "#000000",
            fontFamily: "ubold",
          },
        },
      }}
    >
      <Modal
        width={550}
        maskClosable={false}
        open={openModal}
        onOk={handleOk}
        onCancel={handleCancel}
        title={`Process Order (${params.order.orderNumber})`}
        footer={[
          <button
            key="cancel"
            onClick={handleCancel}
            style={{
              backgroundColor: "#D9D9D9",
              color: "#000000",
              fontFamily: "ubold",
              border: "none",
              padding: "8px 16px",
              borderRadius: "4px",
              cursor: "pointer",
              marginRight: "10px",
            }}
          >
            Close
          </button>,

          <button
            key="ok"
            onClick={handleOk}
            style={{
              backgroundColor: "#FFD700",
              color: "#000000",
              fontFamily: "ubold",
              border: "none",
              padding: "8px 16px",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            refund
          </button>,
        ]}
        styles={{ body: { paddingTop: "0px" } }}
      >
        <div className="flex flex-col font-uregular">
          <CustomLoader />
          <Divider style={{ margin: "5px 0" }} />
          <div className="flex flex-col">
            
              <>
                <Divider style={{ margin: "5px 0", borderColor: "#D3D3D3" }} />
                <div className="flex justify-between font-bold">
                  <div>Total Amount</div>
                  <div className="mb-3 ">{params.order.total.toFixed(2)} TK</div>
                </div>
                <div className="flex justify-between font-bold">
                  <div>Paid Amount</div>
                  <div className="mb-3">{params.order.total.toFixed(2)} TK</div>
                </div>
                
                <Divider style={{ margin: "2px 0", borderColor: "#D3D3D3" }} />
                <div className="flex justify-between font-bold">
                  <div>Refund Amount</div>
                  <div className="mb-0 text-red-600">{totalPayable.toFixed(2)} TK</div>
                </div>
                <Divider style={{ margin: "2px 0 20px 0", borderColor: "#D3D3D3" }} />

                <div className="flex justify-between items-center">
                  <div>Payment Method</div>
                  <div>
                    <ConfigProvider
                      theme={{
                        token: {
                          colorPrimary: "#572D86",
                          colorPrimaryBorder: "#572D86",
                          colorPrimaryHover: "#572D86",
                          controlOutline: "#572D86",
                          colorBorder: "#572D86",
                        },
                      }}
                    >
                      {" "}
                      <div className="flex items-center mb-[2px] ml-[4px]">
                        
                      </div>
                    </ConfigProvider>
                  </div>
                </div>
                <Divider style={{ margin: "5px 0", borderColor: "#D3D3D3" }} />

                <div className="flex justify-between items-center">
                  <div className="mb-3 text-red-600 w-1/3 mr-10">
                    <Select
                      value={paymentMethod}
                      className="w-[100%]"
                      onChange={onSelectPaymentMethod}
                      options={paymentMethodList}
                    />
                  </div>

                  <div className={`mr-4 ${paymentMethod === "CASH" ? "invisible" : "visible"}`}>
                    <input
                      value={defaultRef}
                      className={`w-full rounded-[5px] border-[1px] border-grey font-uregular px-[8px] py-[4px]`}
                      placeholder={"Ref"}
                      onChange={(e) => setDefaultRef(e.target.value)}
                    />
                  </div>

                  <div className="flex">
                    <div>
                      {totalPayable.toFixed(2)}
                    </div>
                    <div className="pl-2">TK</div>
                  </div>
                </div>
              </>
          </div>
          <Divider />
        </div>
      </Modal>
    </ConfigProvider>
  );
}

export default OrderPaymentRefundModal;
